import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const LoginStyled = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;
  min-height: calc(100vh - 96px);
  height: auto;
  background-color: transparent;
  margin-top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: none;
  position: relative;
  padding: 48px 16px 72px;

  /* Child element styles
  ------------------------------- */
  .login-wrapper {
    width: 100%;
    max-width: 420px;
    margin: 0 auto;
    flex-wrap: wrap;
    background-color: #ffffff;
    border-radius: 16px;
    box-shadow: 0 20px 40px -15px rgba(76, 74, 203, 0.14);
    padding: 28px 28px 24px;
  }

  .login-brand {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 22px;
  }

  .login-brand-mark {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    flex: 0 0 36px;
    border-radius: 12px;
    background-color: #6c63ff;

    svg {
      width: 20px;
      height: 20px;
      fill: #ffffff;
    }
  }

  .login-brand-name {
    color: #1f2937;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0.04em;
  }

  .login-brand-sub {
    display: block;
    color: #64748b;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0;
  }

  .notification {
    font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
    font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.MD};
    color: ${VARIABLES.COLORS.GRAY_3};
    margin-bottom: 40px;
  }

  .login-form {
    width: 100%;
    max-width: none;
    flex-wrap: wrap;
    margin-bottom: 0;

    .input-control {
      margin-top: 10px;

      &:first-child {
        margin-top: 0;
      }
    }

    .form-group {
      .input-control {
        max-width: 100%;
      }
    }

    .message {
      color: ${VARIABLES.COLORS.RED_1};
      font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.XS};
      height: 20px;
      margin-bottom: 10px;
    }

    .invalid-message {
      color: ${VARIABLES.COLORS.RED_1};
      font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.XS};
    }

    .button {
      margin-top: 36px;

      &.link {
        margin-top: 0;
        width: 100%;
      }
    }
  }

  .reminding {
    display: inline-block;
    text-align: center;
    padding: 15px 10%;
    margin-bottom: 15vh;
  }

  .update-check {
    position: absolute;
    right: 1%;
    bottom: 2%;

    p {
      color: ${VARIABLES.COLORS.GRAY_14};
      letter-spacing: '3px';
      font-size: '1.2em';
    }
  }

  .support-link {
    position: absolute;
    left: 2%;
    bottom: 2%;
    text-align: left;
  }

  .app-version {
    position: absolute;
    right: 1%;
    bottom: 5.2%;
    text-align: right;

    p {
      color: ${VARIABLES.COLORS.GRAY_14};
      letter-spacing: '3px';
      font-size: '1.2em';
    }
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
    .login-wrapper {
      max-width: 420px;
    }
  }

  @media all and (max-width: 1440.98px) {
    .login-wrapper {
      max-width: 420px;
    }

    .login-form {
      .message {
        font-size: 13px;
        height: 18px;
        margin-bottom: 8px;
      }

      .button {
        margin-top: 32px;
      }
    }
  }

  @media all and (max-width: 1366.98px) {
    .login-wrapper {
      max-width: 420px;
    }

    .login-form {
      .message {
        font-size: 12px;
        height: 17px;
        margin-bottom: 7px;
      }

      .button {
        margin-top: 28px;
      }
    }
  }

  @media all and (max-width: 1280.98px) {
    .login-wrapper {
      max-width: 420px;
    }

    .login-form {
      .message {
        font-size: 11px;
        height: 16px;
        margin-bottom: 5px;
      }

      .button {
        margin-top: 24px;
      }
    }
  }

  @media all and (max-width: 1024.98px) {
    .login-wrapper {
      max-width: 420px;
    }

    .login-form {
      .message {
        font-size: 10px;
        height: 14px;
      }

      .button {
        margin-top: 20px;
      }
    }
  }
`
